import ReactMarkdown from "react-markdown";
import Quote from "./Quote";
import Image from "./Image";
import Vimeo from "./Vimeo";
import YouTube from "./YouTube";
import File from "./File";
import Sketchfab from "./Sketchfab";
import ButtonLink from "./ButtonLink";

import styles from "./ContentBlock.module.css";

/**
 * Renders a block of content depending on its type.
 * @param {Object} inner: the inner content block object
 */
export default function ContentBlock({ inner }) {
  return (
    <div className={styles["content-block"]}>
      {inner.type === "text" ? (
        <ReactMarkdown>{inner.data}</ReactMarkdown>
      ) : // ) : block.type === "plain_text" ? (
      //   <pre>{block.data}</pre>
      inner.type === "html" ? (
        <div dangerouslySetInnerHTML={{ __html: inner.data }} />
      ) : inner.type === "quote" ? (
        <Quote text={inner.data} />
      ) : inner.type === "image" ? (
        <Image src={inner.data} skip_link={inner.skip_link} />
      ) : inner.type === "vimeo" ? (
        <Vimeo id={inner.data} />
      ) : inner.type === "youtube" ? (
        <YouTube id={inner.data} width={inner.width} height={inner.height} />
      ) : inner.type === "file" ? (
        <File label={inner.name} href={inner.data} />
      ) : inner.type === "sketchfab" ? (
        <Sketchfab id={inner.data} />
      ) : inner.type === "button_link" ? (
        <ButtonLink label={inner.name} href={inner.data} />
      ) : // TODO: add support for other block types, e.g. audio, etc.
      null}
    </div>
  );
}
